exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-background[data-v-00e78730]{background-color:#26180b}.form[data-v-00e78730]{display:flex;min-height:100vh;border:2px solid #ffe4e1;flex-direction:column;flex-wrap:wrap;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00e78730","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Auth/Login.vue
// module id = 626
// module chunks = 2